import { render } from "./TheTemplateM.vue?vue&type=template&id=369f8b37&scoped=true&ts=true"
import script from "./TheTemplateM.vue?vue&type=script&lang=ts"
export * from "./TheTemplateM.vue?vue&type=script&lang=ts"

import "./TheTemplateM.vue?vue&type=style&index=0&id=369f8b37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369f8b37"]])

export default __exports__